import authService from "./authService";
import registrationService from "./registrationService";

const iamService = [
    ...authService,
    ...registrationService
]

export default iamService;